module.exports = ".test{\n    width: 100%;\n    height: 40px;\n    text-align: center;\n    background-color: #006dcc;\n    line-height: 40px;\n    font-weight: bold;\n    color: white;\n    position: sticky;\n    top: 0;\n    z-index: 999;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main